/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The LegalEntitySubsidiaryPostRequestDTO model module.
 * @module model/LegalEntitySubsidiaryPostRequestDTO
 * @version v0
 */
export class LegalEntitySubsidiaryPostRequestDTO {
  /**
   * Constructs a new <code>LegalEntitySubsidiaryPostRequestDTO</code>.
   * @alias module:model/LegalEntitySubsidiaryPostRequestDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntitySubsidiaryPostRequestDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntitySubsidiaryPostRequestDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntitySubsidiaryPostRequestDTO} The populated <code>LegalEntitySubsidiaryPostRequestDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntitySubsidiaryPostRequestDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('authorityCode'))
        obj.authorityCode = ApiClient.convertToType(data['authorityCode'], 'String');
      if (data.hasOwnProperty('legalEntityParentCompanyId'))
        obj.legalEntityParentCompanyId = ApiClient.convertToType(data['legalEntityParentCompanyId'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntitySubsidiaryPostRequestDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
LegalEntitySubsidiaryPostRequestDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
LegalEntitySubsidiaryPostRequestDTO.prototype.active = undefined;

/**
 * @member {String} authorityCode
 */
LegalEntitySubsidiaryPostRequestDTO.prototype.authorityCode = undefined;

/**
 * @member {Number} legalEntityParentCompanyId
 */
LegalEntitySubsidiaryPostRequestDTO.prototype.legalEntityParentCompanyId = undefined;

